import { apiErrorMessage } from '../lib/apiError.ts'

export type DeleteAccountResult = { ok: true } | { ok: false; message: string }

type Fetcher = (path: string, init?: RequestInit, retry?: boolean) => Promise<Response>

/**
 * In-app account erasure (App Store 5.1.1(v) / GDPR Art. 17). The password is re-verified server-side.
 * `retry=false`: a wrong password is a 401, which must not trigger a token refresh and a second attempt
 * against the endpoint's 5/min limit.
 */
export async function deleteAccountRequest(apiFetch: Fetcher, password: string): Promise<DeleteAccountResult> {
  const fallback = 'Could not delete your account. Please try again.'
  try {
    const r = await apiFetch('/auth/account', { method: 'DELETE', body: JSON.stringify({ password }) }, false)
    if (r.ok) return { ok: true }
    const body = await r.json().catch(() => ({}))
    return { ok: false, message: apiErrorMessage(body, fallback) }
  } catch {
    return { ok: false, message: fallback }
  }
}
